import { useEffect } from 'react';

import {
  useTagsActions
} from './TagsContext';

import {
  getTags,
} from './restApi';

const TagsLoader = () => {
  const { initializeState, onResponse, onError } = useTagsActions();

  useEffect(() => {
    initializeState();
  }, []);

  useEffect(() => {
    getTags({
      onResponse,
      onError,
      pageNumber: 1,
    });
  }, []);

  return null;
};

export default TagsLoader;
